/* Vm3Zero — PDP wiring (3 Sept 2026)
   Filename is historic: it started as the sticky-bar bridge and now also does
   the DOM work the bundle cards need. Loaded from the "wiring" Custom liquid
   section at the bottom of the product template, so it runs after both the
   buy box and the Vitals widget have mounted.

   Everything here is derived from state that already exists. Nothing stores a
   price, a quantity or a selection of its own — that is the whole point.

   1. STICKY ADD-TO-CART BRIDGE
      The floating bar that appears on scroll is the theme's
      (snippets/sticky-atc.liquid) or an app's. Both were built for the stock
      product section: the theme one carries form="{{ product_form_id }}" and
      posts to a form this template does not render, and neither knows anything
      about the Vitals tier the customer picked. Every click inside the bar is
      caught in the CAPTURE phase, stopped, and forwarded to [data-vz-add] —
      the one button that knows the tier, the quantity and the discount.

   2. BUNDLE CARD DOM
      - the bundle reasons are mirrored into the SELECTED tier card. A copy,
        not a move: the section's own script owns the original node and puts it
        back if it is relocated, so the two would fight forever.
      - the offer badge is found by its TEXT, lifted out to become a direct
        child of its tier card and stripped of Vitals' inline styles.
      - EVERY free-gift row is tagged, not just the first — a ladder can run a
        different gift on each rung.

   3. PER-TIER REASONS
      The section has ONE bundle_perks field shared by every rung, which was
      fine with one rung and wrong with two: the 3-pack was being sold with
      "two full-size tubs". The template can override per pack size:

        window.VZ_TIER_PERKS = { "2": ["…", "…"], "3": ["…", "…"] };

      Keyed by the pack count parsed out of the tier title ("x 2"), which is
      why those titles must keep their "x N". The free-shipping line is NOT
      part of the map — it is still owned by the section, which only shows it
      when the selection actually clears the threshold, and it is prepended
      when present. Two lines plus that one is the whole list; anything longer
      stops being read. No map, or no entry for that pack size, falls back to
      the section's shared field.

   4. PER-VARIANT BUNDLE VISIBILITY
      A bundle offer does not always apply to every size. The Powder's ladder
      is built on the 900g; on the 200g there is no offer to make. The template
      declares which variants hide it:

        window.VZ_HIDE_BUNDLE_VARIANTS = ["200"];

      Case-insensitive substring match against the selected variant's title.

   Everything degrades to "unchanged" if an element is not found. */
(function(){
  'use strict';

  var root = document.querySelector('[data-vz-buybox]');
  if (!root) return;

  var realBtn   = root.querySelector('[data-vz-add]');
  var realPrice = root.querySelector('[data-vz-btn-price]');

  var TIER = '.Vtl-NewVolumeDiscountRadio__TierItem';
  var BADGE_TEXT = /^(most popular|best value|best seller|bestseller|most loved|popular|best deal)$/i;

  var TIER_PERKS = window.VZ_TIER_PERKS || null;

  var HIDE_FOR = [];
  if (window.VZ_HIDE_BUNDLE_VARIANTS && window.VZ_HIDE_BUNDLE_VARIANTS.length){
    for (var h = 0; h < window.VZ_HIDE_BUNDLE_VARIANTS.length; h++){
      HIDE_FOR.push(String(window.VZ_HIDE_BUNDLE_VARIANTS[h]).toLowerCase());
    }
  }

  function textOf(el){
    return (el && el.textContent || '').replace(/\s+/g, ' ').trim();
  }

  function esc(s){
    return String(s).replace(/[&<>]/g, function(c){
      return c === '&' ? '&amp;' : c === '<' ? '&lt;' : '&gt;';
    });
  }

  /* ==================== 1. STICKY BAR ==================== */

  var STICKY_SEL = [
    '.sticky-atc',
    '[class*="sticky-atc"]',
    '[class*="sticky-add-to-cart"]',
    '[class*="StickyAddToCart"]',
    '[class*="vtl-sticky"]',
    '[class*="Vtl-Sticky"]'
  ].join(',');

  function bars(){
    var all = document.querySelectorAll(STICKY_SEL);
    var out = [];
    for (var i = 0; i < all.length; i++){
      var el = all[i];
      if (root.contains(el)) continue;
      var nested = false;
      for (var j = 0; j < out.length; j++){
        if (out[j].contains(el)) { nested = true; break; }
      }
      if (!nested) out.push(el);
    }
    return out;
  }

  function bindBar(bar){
    if (bar.getAttribute('data-vz-sticky-bound')) return;
    bar.setAttribute('data-vz-sticky-bound', '1');

    bar.addEventListener('click', function(e){
      var t = e.target;
      if (!t || typeof t.closest !== 'function') return;
      if (t.closest('select, option, [class*="dropdown"]')) return;

      var hit = t.closest('button, input[type="submit"], [role="button"]');
      if (!hit) return;

      e.preventDefault();
      e.stopPropagation();
      if (e.stopImmediatePropagation) e.stopImmediatePropagation();

      if (realBtn && !realBtn.disabled) realBtn.click();
    }, true);
  }

  function paintBar(bar){
    if (realPrice){
      var txt = (realPrice.textContent || '').trim();
      var p = bar.querySelector('.sticky-atc__price')
           || bar.querySelector('[class*="price"], [class*="Price"]');
      if (txt && p && (p.textContent || '').trim() !== txt) p.textContent = txt;
    }
    if (!realBtn) return;
    var btns = bar.querySelectorAll('button, input[type="submit"]');
    for (var i = 0; i < btns.length; i++) btns[i].disabled = !!realBtn.disabled;
  }

  /* ==================== 2. BUNDLE CARDS ==================== */

  var perksSrc = root.querySelector('[data-vz-perks]');

  function widget(){
    var t = root.querySelector(TIER);
    if (!t) return null;
    return (t.closest && (t.closest('.vtl-ub-vd-widget') || t.closest('[class*="vtl-ub-vd"]'))) || null;
  }

  function selectedTier(){
    var tiers = root.querySelectorAll(TIER);
    for (var i = 0; i < tiers.length; i++){
      var t = tiers[i];
      if (t.classList.contains('Vtl-NewVolumeDiscountRadio__TierItem--Selected')) return t;
      if (t.querySelector('[aria-checked="true"]')) return t;
      var r = t.querySelector('input[type="radio"]');
      if (r && r.checked) return t;
    }
    return null;
  }

  function tierLabel(tier){
    return tier.querySelector('[data-vtl-el="tier-label"]')
        || tier.querySelector('[role="radio"]')
        || tier.querySelector('label')
        || tier;
  }

  /* Pack count out of the tier title — "Odour Control Powder x 3" → "3".
     The buy box parses the same thing for the cart, so the titles have to
     keep their "x N". */
  function tierQty(tier){
    var el = tier.querySelector('.Vtl-NewVolumeDiscountRadio__LabelHeaderQuantity');
    var m = el && (el.textContent || '').match(/\d+/);
    if (m) return m[0];
    var txt = textOf(tier);
    m = txt.match(/[x×]\s*(\d+)/i) || txt.match(/(\d+)\s*[x×]/i);
    return m ? m[1] : null;
  }

  function perksHtmlFor(tier){
    if (!perksSrc) return '';
    if (!TIER_PERKS) return perksSrc.innerHTML;

    var qty   = tierQty(tier);
    var lines = qty ? TIER_PERKS[qty] : null;
    if (!lines || !lines.length) return perksSrc.innerHTML;

    var html = '';
    /* The section decides whether free shipping is true for this selection.
       Keep its wording, drop its attribute so the section's own reference
       still points at the original node and not at our copy. */
    var ship = perksSrc.querySelector('[data-vz-perk-ship]');
    if (ship && !ship.hasAttribute('hidden')) html += '<li>' + esc(textOf(ship)) + '</li>';

    for (var i = 0; i < lines.length; i++) html += '<li>' + esc(lines[i]) + '</li>';
    return html;
  }

  /* Mirror the reasons into the chosen card. innerHTML is compared before it
     is written so this is a no-op once settled — otherwise our own writes
     would retrigger the section's MutationObserver in a loop. */
  function placePerks(){
    if (!perksSrc) return;
    var tiers = root.querySelectorAll(TIER);
    if (!tiers.length) return;
    var sel = selectedTier();

    for (var i = 0; i < tiers.length; i++){
      var tier  = tiers[i];
      var clone = tier.querySelector('[data-vz-perks-clone]');

      if (tier !== sel){
        if (clone && clone.parentNode) clone.parentNode.removeChild(clone);
        continue;
      }
      if (!clone){
        clone = document.createElement('ul');
        clone.className = 'vz-plan__perks vz-perks--clone';
        clone.setAttribute('data-vz-perks-clone', '');
        tier.appendChild(clone);
      }
      var html = perksHtmlFor(tier);
      if (clone.innerHTML !== html) clone.innerHTML = html;
    }
  }

  /* One badge per tier card, lifted out to sit directly on the card. */
  function placeBadges(){
    var tiers = root.querySelectorAll(TIER);

    for (var i = 0; i < tiers.length; i++){
      var tier  = tiers[i];
      var badge = tier.querySelector('.vz-tier-badge');

      if (!badge){
        var all = tier.querySelectorAll('*');
        for (var j = 0; j < all.length; j++){
          var el = all[j];
          if (el.children.length) continue;
          if (!BADGE_TEXT.test(textOf(el))) continue;

          var node = el;
          while (node.parentNode
                 && node.parentNode !== tier
                 && BADGE_TEXT.test(textOf(node.parentNode))){
            node = node.parentNode;
          }
          node.classList.add('vz-tier-badge');
          badge = node;
          break;
        }
      }
      if (!badge) continue;

      if (badge.getAttribute('style')) badge.removeAttribute('style');

      if (badge.parentNode !== tier){
        var orphan = badge.parentNode;
        tier.appendChild(badge);

        while (orphan && orphan !== tier && !textOf(orphan)
               && !orphan.querySelector('img, svg, input')){
          orphan.classList.add('vz-badge-orphan');
          orphan = orphan.parentNode;
        }
      }
    }
  }

  /* EVERY gift row, not just the first. */
  function tagGifts(){
    var w = widget();
    if (!w) return;
    var all = w.querySelectorAll('*');

    for (var i = 0; i < all.length; i++){
      var el = all[i];
      if (el.children.length) continue;
      if (!/^free\b/i.test(textOf(el))) continue;

      /* Our own tick list also starts a line with "Free shipping…" — that is
         a perk, not a gift, and must not be boxed. */
      if (el.closest('.vz-plan__perks')) continue;
      if (el.closest('.vz-gift-row')) continue;

      var node = el;
      while (node.parentNode
             && node.parentNode !== w
             && !(node.parentNode.matches && node.parentNode.matches(TIER))
             && !node.parentNode.classList.contains('vz-gift-row')
             && (node.parentNode.textContent || '').trim().length < 120){
        node = node.parentNode;
      }
      node.classList.add('vz-gift-row');
    }
  }

  /* ==================== 4. PER-VARIANT VISIBILITY ==================== */

  function selectedVariantTitle(){
    var input = root.querySelector('[data-vz-variant-option]:checked');
    if (!input) return '';
    var label = input.closest ? input.closest('label') : null;
    var b = label && label.querySelector('b');
    return textOf(b || label || input);
  }

  var lastVariant = null;
  var clearTries  = 0;

  function applyBundleVisibility(){
    if (!HIDE_FOR.length) return;

    var title = selectedVariantTitle().toLowerCase();
    if (title !== lastVariant){ lastVariant = title; clearTries = 0; }

    var hide = false;
    for (var i = 0; i < HIDE_FOR.length; i++){
      if (title.indexOf(HIDE_FOR[i]) > -1){ hide = true; break; }
    }

    if (root.classList.contains('vz-bundle-off') !== hide){
      root.classList.toggle('vz-bundle-off', hide);
    }

    /* Hiding is not enough: a tier selected before the size changed would
       still drive the price and the cart. Click it off, capped so a widget
       that refuses to deselect cannot become a click loop. */
    if (hide && clearTries < 3){
      var tier = selectedTier();
      if (tier){
        clearTries++;
        var lbl = tierLabel(tier);
        if (lbl) lbl.click();
      }
    }
  }

  /* ==================== TICK ==================== */

  function tick(){
    var list = bars();
    for (var i = 0; i < list.length; i++){ bindBar(list[i]); paintBar(list[i]); }
    placePerks();
    placeBadges();
    tagGifts();
    applyBundleVisibility();
  }

  tick();

  if (realPrice && window.MutationObserver){
    new MutationObserver(tick).observe(realPrice, {
      childList: true, characterData: true, subtree: true
    });
  }

  if (window.MutationObserver){
    new MutationObserver(tick).observe(root, {
      subtree: true, childList: true,
      attributes: true, attributeFilter: ['class', 'aria-checked', 'hidden', 'checked']
    });
  }

  /* A radio's `checked` property changing does not always fire an attribute
     mutation, so listen for the change event too. */
  root.addEventListener('change', tick);

  var tries = 0;
  var timer = setInterval(function(){
    tick();
    if (++tries > 30) clearInterval(timer);
  }, 500);

  document.addEventListener('click', tick, true);
  window.addEventListener('scroll', function(){
    if (window.requestAnimationFrame) window.requestAnimationFrame(tick);
    else tick();
  }, { passive: true });
})();
